import React from 'react';
import classNames from 'classnames';

import { useResponsiveBreakpoints } from '../../../../hooks/useResponsiveBreakpoints';

import StepsSection from '../StepsSection/StepsSection';
import LabelsSection from '../LabelsSection/LabelsSection';
import ContentSection from '../ContentSection/ContentSection';

const PlaybookTemplateMainContent = ({ playbookTemplate, setPlaybookTemplate, isEditable }) => {
    const { id, labels, icon_color, default_version } = playbookTemplate;
    const { steps, details } = default_version;

    const { isDesktop } = useResponsiveBreakpoints();

    const setLabels = (cb) => {
        setPlaybookTemplate((template) => ({
            ...template,
            labels: typeof cb === 'function' ? cb(template.labels || []) : cb,
        }));
    };

    const className = classNames(
        'flex-grow bg-neutral-50',
        'pt-5 pb-[40px] px-4 xs:px-5 md:px-8 lg:px-[40px] xl:px-[72px]',
        'flex flex-col gap-6 lg:grid lg:grid-cols-[minmax(100px,_2fr)_minmax(100px,_1.25fr)] xl:grid-cols-[minmax(100px,_2fr)_minmax(100px,_1fr)] 2xl:grid-cols-[minmax(100px,_2fr)_minmax(100px,_1.2fr)] gap-4 lg:gap-6 2xl:gap-8 lg:justify-center'
    );

    return (
        <div className={className}>
            <div className="flex flex-col gap-6">
                {!isDesktop && (
                    <LabelsSection
                        labels={labels || []}
                        setLabels={setLabels}
                        isEditable={isEditable}
                        shouldSaveChanges
                        playbookTemplateId={id}
                    />
                )}

                <StepsSection
                    steps={steps}
                    icon_color={icon_color}
                    playbookTemplateId={id}
                    setPlaybookTemplate={setPlaybookTemplate}
                    isEditable={isEditable}
                />
            </div>

            <div className="flex flex-col gap-6">
                {isDesktop && (
                    <LabelsSection
                        labels={labels || []}
                        setLabels={setLabels}
                        isEditable={isEditable}
                        shouldSaveChanges
                        playbookTemplateId={id}
                    />
                )}

                <ContentSection
                    content={details?.content}
                    playbookTemplateId={id}
                    setPlaybookTemplate={setPlaybookTemplate}
                    isEditable={isEditable}
                />
            </div>
        </div>
    );
};

export default PlaybookTemplateMainContent;
